import bgm from '../music/bgm.mp3'
import bruh from '../music/bruh.mp3'
import player_img from '../images/kentoshi.png'
import player_ss from '../images/kentoshi_w80.png'
import background from '../images/bg_kyodai.jpg'
import background_2 from '../images/bg_kyodai_2.jpg'
import cow1 from '../images/unit_1.png'
import cow2 from '../images/unit_2.png'
import cow3 from '../images/unit_3.png'
import cow4 from '../images/unit_4.png'
import cow5 from '../images/unit_5.png'
import cow6 from '../images/unit_6.png'
import cow7 from '../images/unit_7.png'
import cow8 from '../images/unit_8.png'
import cow9 from '../images/unit_9.png'
import cow10 from '../images/unit_10.png'
import cow11 from '../images/unit_11.png'
import cow12 from '../images/unit_12.png'
import cow13 from '../images/unit_13.png'
import cow14 from '../images/unit_14.png'
import cow15 from '../images/unit_15.png'
import cow16 from '../images/unit_16.png'
import cow17 from '../images/unit_17.png'
import cow18 from '../images/unit_18.png'
import cow19 from '../images/unit_19.png'
import cow20 from '../images/unit_20.png'
import cow21 from '../images/unit_21.png'
import rank0 from '../images/rank_0.png'
import rank1 from '../images/rank_1.png'
import rank2 from '../images/rank_2.png'
import rank3 from '../images/rank_3.png'
import rank4 from '../images/rank_4.png'
import rank5 from '../images/rank_5.png'
import rank6 from '../images/rank_6.png'
import rank7 from '../images/rank_7.png'
import rank8 from '../images/rank_8.png'
import rank9 from '../images/rank_9.png'
import rank10 from '../images/rank_10.png'
// import yourrank from '../images/txt_your-rank.png'
import titleImg from '../images/ttl_graduate_time.png'
import success30 from '../images/ttl_success.png'
import failure30 from '../images/ttl_fail.png'
import rank_txt from '../images/rank_txt.png'
import ryunen_success from '../images/txt_success.png'
import ryunenoomoi from '../images/iihanashi.png'
import startbtn from '../images/txt_tap-start.png'
import btn_tweet from '../images/btn_tweet.png'
import btn_oubo from '../images/btn_oubo.png'
import btn_back from '../images/btn_back.png'
import btn_replay from '../images/btn_replay.png'

import Cookies from 'js-cookie';

// phina.js をグローバル領域に展開
phina.globalize();
var l = 640, c = 960, u = 800;

const SCREEN_WIDTH = 640
const SCREEN_HEIGHT = 960
const OBJECT_POSITION = 800

const ASSETS = {
    sound: {
        'bgm': bgm,
        'bruh': bruh,
    },
    image: {
        'titleImg': titleImg,
        'player_img': player_img,
        'player': player_ss,
        'cow1': cow1,
        'cow2': cow2,
        'cow3': cow3,
        'cow4': cow4,
        'cow5': cow5,
        'cow6': cow6,
        'cow7': cow7,
        'cow8': cow8,
        'cow9': cow9,
        'cow10': cow10,
        'cow11': cow11,
        'cow12': cow12,
        'cow13': cow13,
        'cow14': cow14,
        'cow15': cow15,
        'cow16': cow16,
        'cow17': cow17,
        'cow18': cow18,
        'cow19': cow19,
        'cow20': cow20,
        'cow21': cow21,
        'rank0': rank0,
        'rank1': rank1,
        'rank2': rank2,
        'rank3': rank3,
        'rank4': rank4,
        'rank5': rank5,
        'rank6': rank6,
        'rank7': rank7,
        'rank8': rank8,
        'rank9': rank9,
        'rank10': rank10,
        // 'yourrank': yourrank,
        'background': background,
        'background_2': background_2,
        'success30': success30,
        'failure30': failure30,
        'rank_txt': rank_txt,
        'ryunen_success': ryunen_success,
        'ryunenoomoi': ryunenoomoi,
        'startbtn': startbtn,
        'btn_tweet': btn_tweet,
        'btn_back': btn_back,
        'btn_replay': btn_replay,
        'btn_oubo': btn_oubo,
    },
    // スプライトシート
    // spritesheet: {
    //     "player_ss":
    //         {
    //             // フレーム情報
    //             "frame": {
    //                 "width": 73, // 1フレームの画像サイズ（横）
    //                 "height": 73, // 1フレームの画像サイズ（縦）
    //                 "cols": 3, // フレーム数（横）
    //                 "rows": 3, // フレーム数（縦）
    //             },
    //             // アニメーション情報
    //             "animations": {
    //                 "walk": { // アニメーション名
    //                     "frames": [0, 1, 2, 3, 4, 5, 6, 7], // フレーム番号範囲
    //                     "next": "walk", // 次のアニメーション
    //                     "frequency": 6, // アニメーション間隔
    //                 },
    //             }
    //         },
    // }
}

/**
 * TitleScene
 */
phina.define("Title", {
    superClass: "DisplayScene", init: function () {
        this.superInit(),
            Sprite("background").addChildTo(this).setPosition(this.gridX.center(), this.gridY.center());
        // Label({
        //     text: "３０秒クリア",
        //     fontSize: 48,
        //     fill: "#000000"
        // }).addChildTo(this).setPosition(this.gridX.center(), this.gridY.span(4)),
        Sprite("titleImg", 481, 330).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center()).moveBy(0, -280);
        Sprite("startbtn", 386, 45).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center()).moveBy(0, -70);
        Sprite("player_img", 200, 344).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center()).moveBy(-20, 300);
    }, onpointstart: function () {
        SoundManager.playMusic("bgm"), this.exit()
    }
})

/**
 * Result
 */
phina.define("Result", {
    superClass: "DisplayScene", init: function (i, keika) {
        let bestscore = 0;
        bestscore = Cookies.get('bestScore1');
        if (bestscore === undefined || (bestscore !== undefined && i.score > bestscore)) {
            Cookies.set('bestScore1', i.score, {expires: 999});
        }
        // console.log("result構築");
        var e = this;
        this.superInit(i)

        SoundManager.stopMusic();

        Sprite("background").addChildTo(this).setPosition(this.gridX.center(), this.gridY.center())
        // Label({
        //     text: "評価",
        //     fill: '#a4ff60',
        //     fontSize: 24
        // })
        //     .addChildTo(this).setPosition(this.gridX.center(), this.gridY.span(7)),

        // this.time = 30000;
        // // 経過時間更新
        // this.time -= i.deltaTime;
        // // console.log(this.time);
        // // 経過秒数表示
        // keika = Math.floor(this.time / 1000);

        // console.log("time_score::" + i.time_score);
        if (i.time_score <= 0) {
            Sprite("success30", 500, 100).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center()).moveBy(0, -380);
            // Sprite("yourrank").addChildTo(this).setPosition(this.gridX.center(), this.gridY.center(-1.7));
        } else {
            Sprite("failure30", 500, 100).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center()).moveBy(0, -380);
        }

        // Sprite("titleImg", 300, 170).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center(-5.5))

        Label({
            text: "落とした単位数：" + i.score,
            fontSize: 20,
            fill: "#0000ff"
        }).addChildTo(this).setPosition(this.gridX.center(), this.gridY.span(5)).moveBy(0, -120);

        var t = "";
        // // i.score <= 10 ? t = "💩" : i.score > 10 && i.score <= 30 ? t = "😕" : i.score > 30 && i.score <= 50 ? t = "😯" : i.score > 50 && i.score <= 70 ? t = "😀" : i.score > 70 && i.score <= 90 ? t = "😏" : i.score > 90 && i.score <= 110 ? t = "😎" : i.score > 110 && i.score <= 200 ? t = "🐄" : i.score > 200 && (t = "👑"),
        // i.score <= 10 ? Sprite("rank1", 100, 100).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center(0)) :
        //     i.score > 10 && i.score <= 30 ? Sprite("rank1", 100, 100).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center(0))
        //         : i.score > 30 && i.score <= 50 ? Sprite("rank3", 100, 100).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center(0))
        //         : i.score > 50 && i.score <= 70 ? Sprite("rank4", 100, 100).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center(0))
        //             : i.score > 70 && i.score <= 90 ? Sprite("rank5", 100, 100).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center(0))
        //                 : i.score > 90 && i.score <= 110 ? Sprite("rank5", 100, 100).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center(0))
        //                     : i.score > 110 && i.score <= 200 ? Sprite("rank5", 100, 100).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center(0))
        //                         : i.score > 200 && (Sprite("rank5", 100, 100).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center(0))),

        Label({
            text: t,
            fill: '#a4ff60',
            fontSize: 64
        }).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center());

        if (i.time_score <= 0) {
            Sprite("ryunen_success", 500, 150).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center()).moveBy(0, -180);
            Sprite("ryunenoomoi", 500, 270).addChildTo(this).setPosition(this.gridX.center(), this.gridY.center()).moveBy(0, 300);

            // var sprite_tw = Sprite("btn_tweet", 500, 60).setPosition(this.gridX.center(), this.gridY.center()).moveBy(0, -30).addChildTo(this);
            var ua = window.navigator.userAgent.toLowerCase();
            if(ua.indexOf('ipad') > -1
                || ua.indexOf('macintosh') > -1 && 'ontouchend' in document){
                // iPad用の処理
                Button({
                    text: "ツイートする",
                    fontColor: '#0000ff',
                    fill: "#b1b1b1"
                }).setPosition(this.gridX.center(), this.gridY.center()).moveBy(0, -30).addChildTo(this).on("push", function () {
                    var e = "{0}".format("\n" +
                        "（この文を削除して是非感想を追加してね♪）\n——————————————\n" + "🔥おめでとうございます🔥\n" +
                        "あなたの留年が無事確定しました🧑🏻‍🎓\n" +
                        "手に入れた1年で、ジャンカラライフを味わい尽くせ🎤"), t = phina.social.Twitter.createURL({
                        text: e,
                        hashtags: ["ジャンカラ"],
                        url: "https://jankara.ne.jp/kuso-game/pikopiko/"
                    });
                    window.open(t, "share window", "width=480, height=320")
                })
            }else{
                // それ以外の端末用の処理
                var sprite_tw = Sprite("btn_tweet", 500, 60).setPosition(this.gridX.center(), this.gridY.center()).moveBy(0, -30).addChildTo(this);
                sprite_tw.setInteractive(true);
                sprite_tw.onclick = function () {
                    var e = "{0}".format("\n" +
                        "（この文を削除して是非感想を追加してね♪）\n——————————————\n" + "🔥おめでとうございます🔥\n" +
                        "あなたの留年が無事確定しました🧑🏻‍🎓\n" +
                        "手に入れた1年で、ジャンカラライフを味わい尽くせ🎤"), t = phina.social.Twitter.createURL({
                        text: e,
                        hashtags: ["ジャンカラ"],
                        url: "https://jankara.ne.jp/kuso-game/pikopiko/"
                    });
                    window.open(t, "share window", "width=480, height=320")
                };
            }
            var sprite_rep = Sprite("btn_replay", 200, 60).setPosition(this.gridX.center(), this.gridY.center()).moveBy(-120, 90).addChildTo(this);
            sprite_rep.setInteractive(true);
            sprite_rep.onpointstart = function () {
                SoundManager.playMusic("bgm")
                e.exit()
            };

            var sprite_back = Sprite("btn_back", 200, 60).setPosition(this.gridX.center(), this.gridY.center()).moveBy(120, 90).addChildTo(this);
            sprite_back.setInteractive(true);
            sprite_back.onpointstart = function () {
                window.location.href = '/kuso-game/pikopiko/#yobun-score';
            };
        } else {
            var ua = window.navigator.userAgent.toLowerCase();
            if(ua.indexOf('ipad') > -1
                || ua.indexOf('macintosh') > -1 && 'ontouchend' in document){
                // iPad用の処理
                Button({
                    text: "ツイートする",
                    fontColor: '#0000ff',
                    fill: "#b1b1b1"
                }).setPosition(this.gridX.center(), this.gridY.center()).moveBy(0, -180).addChildTo(this).on("push", function () {
                    var e = "{0}".format("\n" +
                        "（この文を削除して是非感想を追加してね♪）\n——————————————\n" + "🥺お気の毒に🥺\n" +
                        "狂大をストレートで卒業してしまいました…\n" +
                        "社会人は息抜きが大切。\n" +
                        "ジャンカラで歌ってストレス解消🎤"), t = phina.social.Twitter.createURL({
                        text: e,
                        hashtags: "ジャンカラ",
                        url: "https://jankara.ne.jp/kuso-game/pikopiko/"
                    });
                    window.open(t, "share window", "width=480, height=320")
                })
            }else{
                // それ以外の端末用の処理
                var sprite_tw = Sprite("btn_tweet", 500, 60).setPosition(this.gridX.center(), this.gridY.center()).moveBy(0, -180).addChildTo(this);
                sprite_tw.setInteractive(true);
                sprite_tw.onclick = function () {
                    var e = "{0}".format("\n" +
                        "（この文を削除して是非感想を追加してね♪）\n——————————————\n" + "🥺お気の毒に🥺\n" +
                        "狂大をストレートで卒業してしまいました…\n" +
                        "社会人は息抜きが大切。\n" +
                        "ジャンカラで歌ってストレス解消🎤"), t = phina.social.Twitter.createURL({
                        text: e,
                        hashtags: "ジャンカラ",
                        url: "https://jankara.ne.jp/kuso-game/pikopiko/"
                    });
                    window.open(t, "share window", "width=480, height=320")
                };

            }
            var sprite_rep = Sprite("btn_replay", 200, 60).setPosition(this.gridX.center(), this.gridY.center()).moveBy(-120, -50).addChildTo(this);
            sprite_rep.setInteractive(true);
            sprite_rep.onpointstart = function () {
                SoundManager.playMusic("bgm")
                e.exit()
            };

            var sprite_back = Sprite("btn_back", 200, 60).setPosition(this.gridX.center(), this.gridY.center()).moveBy(120, -50).addChildTo(this);
            sprite_back.setInteractive(true);
            sprite_back.onpointstart = function () {
                window.location.href = '/kuso-game/pikopiko/#yobun-score';
            };
        }
    }
})

/**
 * Main
 */
phina.define("Main", {
    superClass: "DisplayScene", init: function () {
        this.superInit({
            width: SCREEN_WIDTH,
            height: SCREEN_HEIGHT
        }),
            Sprite("background_2").addChildTo(this).setPosition(this.gridX.center(), this.gridY.center());
        // TiledSprite("background")
        //     .setPosition(this.gridX.center(), this.gridY.center())
        //     .addChildTo(this)
        //     .on('enterframe', function () {
        //         // 毎フレーム行う処理
        //         // this.offsetX += 10;
        //         this.offsetY += -10;
        //     }),
        this.score = 0,
            this.time_score = 30;
        this.scoreLabel = Label({text: '落とした単位数：' + this.score, fill: '#0000ff'}).addChildTo(this);
        this.scoreLabel.x = this.gridX.center();
        this.scoreLabel.y = this.gridY.span(1);
        this.bombGroup = DisplayElement().addChildTo(this);
        this.player = Sprite("player", 80, 137).addChildTo(this);
        this.player.setPosition(320, u);
        // this.player.setPosition(this.gridX.center(), this.gridY.center());
        // スプライトにフレームアニメーションをアタッチ
        // var anim = FrameAnimation('player_ss').attachTo(this.player);
        // アニメーションを指定する
        // anim.gotoAndPlay('walk');

        // 経過時間ラベル
        this.label2 = Label({
            text: '',
            fontSize: 48,
            fill: '#0000ff',
            x: this.gridX.center(),
            y: this.gridY.center(),
        }).addChildTo(this).moveBy(0, -170);
        // 経過時間管理用変数
        this.time = 31000;

    }, update: function (i) {
        // console.log(i.deltaTime);
        // 経過時間更新
        this.time -= i.deltaTime;
        // console.log(this.time);
        // 経過秒数表示
        var keika = Math.floor(this.time / 1000);
        this.time_score = keika;
        this.label2.text = '残り' + keika + '秒';

        var e = i.pointer;
        // Result(i, keika);
        e.getPointing() && (e.x < 0 ? this.player.setPosition(0, u) : e.x > 640 ? this.player.setPosition(640, u) : this.player.setPosition(e.x, u));

        this.bombGroup.children.forEach(function (i) {
            this.height < i.y && (this.score += 1, this.scoreLabel.text = this.score, i.remove()), this.player.hitTestElement(i) && this.gameover()
        }.bind(this));
        i.frame % 10 == 0 &&
        this.spawnBomb()
        //タイムアタック
        if (keika === 0) {
            this.time_score = keika;
            this.gameover();
        }
    }, spawnBomb: function () {
        // 経過時間更新
        // this.time += i.deltaTime;
        // 経過秒数表示
        var keika = Math.floor(this.time / 1000);

        // console.log(keika);
        var i = Math.randint(0, this.width);
        // Bomb(i, -100, keika).addChildTo(this.bombGroup);
        Bomb(i, -100, keika).addChildTo(this.bombGroup);
    }, gameover: function () {
        SoundManager.setVolume(2), SoundManager.play("bruh"), this.exit({
            score: this.score,
            time_score: this.time_score
        })
    }
})

/*
 * enemy
 */
phina.define("Bomb", {
    superClass: "phina.display.Sprite", init: function (i, e, keika) {
        switch (Math.randint(1, 21)) {
            case 1:
                this.superInit("cow1", 40, 96);
                break;
            case 2:
                this.superInit("cow2", 40, 96);
                break;
            case 3:
                this.superInit("cow3", 40, 96);
                break;
            case 4:
                this.superInit("cow4", 40, 96);
                break;
            case 5:
                this.superInit("cow5", 40, 96);
                break;
            case 6:
                this.superInit("cow6", 40, 96);
                break;
            case 7:
                this.superInit("cow7", 40, 96);
                break;
            case 8:
                this.superInit("cow8", 40, 96);
                break;
            case 9:
                this.superInit("cow9", 40, 96);
                break;
            case 10:
                this.superInit("cow10", 40, 96);
                break;
            case 11:
                this.superInit("cow11", 96, 40);
                break;
            case 12:
                this.superInit("cow12", 96, 40);
                break;
            case 13:
                this.superInit("cow13", 96, 40);
                break;
            case 14:
                this.superInit("cow14", 96, 40);
                break;
            case 15:
                this.superInit("cow15", 96, 40);
                break;
            case 16:
                this.superInit("cow16", 96, 40);
                break;
            case 17:
                this.superInit("cow17", 96, 40);
                break;
            case 18:
                this.superInit("cow18", 96, 40);
                break;
            case 19:
                this.superInit("cow19", 96, 40);
                break;
            case 20:
                this.superInit("cow20", 96, 40);
                break;
            case 21:
                this.superInit("cow21", 96, 40);
                break;
        }
        // var t = Math.randint(10, 80);
        var t = Math.randint(50, 60);
        this.accel = t, this.setPosition(i, e);

        // console.log(keika)
        // 経過時間管理用変数
        this.keika = keika;

    }, update: function () {
        // console.log(this.keika)
        // 経過時間更新
        // this.time += app.deltaTime;
        // 経過秒数表示
        // var keika = Math.floor(this.time / 1000);
        // console.log(this.keika)
        if (this.keika >= 20) {
            // console.log("20～")
            // this.y += this.accel - 40
            this.y += this.accel - 40
        } else if (this.keika >= 10) {
            // console.log("10～")
            // this.y += this.accel - 45
            this.y += this.accel - 40
        } else if (this.keika < 10) {
            // console.log("0～")
            // this.y += this.accel - 50
            this.y += this.accel - 40
        }
    }
})

// メイン処理
phina.main(function () {
    var app = GameApp({
        width: SCREEN_WIDTH,
        height: SCREEN_HEIGHT,
        assets: ASSETS,
        debug: !1,
        startLabel: "Title",
        scenes: [{className: "Title", label: "Title", nextLabel: "Main"}, {
            className: "Main",
            label: "Main",
            nextLabel: "Result"
        }, {className: "Result", label: "Result", nextLabel: "Main"}]
    });
    app.domElement.addEventListener("touchend", function e() {
        var t = phina.asset.Sound();
        t.loadFromBuffer(), t.play().stop(), app.domElement.removeEventListener("touchend", e)
    }), app.run()
});